import React, { useCallback, useEffect, useState } from 'react';
import { adminOrdersAPI } from '../../api/admin';
import { Card, Input, Btn, Row, Table, Badge, Empty, Pager, fmtDate } from './ui';

// 접수 내역 — 홈페이지에서 들어온 접수(의뢰자·구간·차량·결제구분·인성 오더번호)
const DISPATCH = { sent: ['on', '인성 접수'], failed: ['off', '전송 실패'], consult: ['default', '상담 건'], pending: ['default', '대기'] };

function AdminOrders() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [q, setQ] = useState('');
  const limit = 20;

  const load = useCallback(async (p = 1, query = q) => {
    const resp = await adminOrdersAPI({ page: p, limit, q: query || undefined });
    if (resp && resp.status === 200) { setRows(resp.data.rows || []); setTotal(resp.data.total || 0); setPage(resp.data.page || p); }
  }, [q]);
  useEffect(() => { load(1, ''); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const search = (e) => { e.preventDefault(); load(1, q); };

  return (
    <Card title="홈페이지 접수" desc={`${total}건`} action={(
      <form onSubmit={search}><Row><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="접수번호 · 의뢰자 · 상호 · 인성 오더번호" style={{ width: 280, height: 36 }} /><Btn tone="ghost" size="sm" type="submit">검색</Btn></Row></form>
    )}>
      {!rows.length ? <Empty>접수가 없습니다.</Empty> : (
        <Table head={['접수번호', '서비스', '의뢰자', '구간', '차량', '결제', '인성', '시각']}>
          {rows.map((o) => {
            const [tone, label] = DISPATCH[o.dispatchStatus] || ['default', o.dispatchStatus];
            return (
              <tr key={o.id}>
                <td style={{ fontSize: 12 }}>{o.orderNumber}</td>
                <td><Badge>{o.serviceName}</Badge></td>
                <td>{[o.requester.company, o.requester.name].filter(Boolean).join(' · ') || '-'}<div style={{ fontSize: 12, color: '#a4a4ac' }}>{o.requester.tel}</div></td>
                <td style={{ fontSize: 12, maxWidth: 260 }}>{o.startAddr}<br />→ {o.endAddr}</td>
                <td>{o.vehicleLabel || '-'}</td>
                <td>{o.payLabel}</td>
                <td><Badge tone={tone}>{label}</Badge>{o.serialNumber && <div style={{ fontSize: 12, marginTop: 4 }}>{o.serialNumber}</div>}{o.dispatchError && <div style={{ fontSize: 11, color: '#d64545', maxWidth: 160 }}>{o.dispatchError}</div>}</td>
                <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{fmtDate(o.createdAt)}</td>
              </tr>
            );
          })}
        </Table>
      )}
      <Pager page={page} limit={limit} total={total} onChange={(p) => load(p, q)} />
    </Card>
  );
}

export default AdminOrders;
